import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/tokens.css';
import './index.css';
import { registerServiceWorker } from './lib/registerSW';
import { initSentry } from './lib/sentry';

// 3.9s — Sentry must initialize BEFORE React mounts so it can catch
// errors thrown during the very first render. No-op if VITE_SENTRY_DSN
// isn't set (dev mode).
initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Wave 1 PR-2 — kick off the PWA service worker after mount. Failures
// are non-fatal (dev mode, http context, browser without SW support).
registerServiceWorker();
